import React, { useContext, useState } from 'react'
import { resetPasswordSchema } from '../../../util/validationSchema'
import { Controller, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { SpinnerContext } from '../../../context/spinnerContext'
import { useDispatch } from 'react-redux'
import { resetPassword } from '../../../redux/slices/authSlice'
import { errorToast, successToast } from '../../../util/Toast/toast'
import { useNavigate, useSearchParams } from 'react-router-dom'

const ResetPassword = () => {
  const [showPassword, setShowPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)
  const { changeLoader } = useContext(SpinnerContext)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  // const { token } = useParams()

  // Get search params
  const [searchParams] = useSearchParams()

  // Access token from query params
  const token = searchParams.get('token')

  const onPasswordEyeClick = () => setShowPassword(!showPassword)
  const onConfirmPasswordEyeClick = () => setShowConfirmPassword(!showConfirmPassword)

  const {
    handleSubmit,
    formState: { errors },
    control,
    trigger
  } = useForm({ resolver: yupResolver(resetPasswordSchema) })

  const onSubmit = (data) => {
    const payload = {
      token: token,
      password: data?.password
    }
    if (payload) {
      changeLoader(true)
      dispatch(resetPassword(payload)).then(({ payload }) => {
        if (payload?.status === 200) {
          successToast(payload?.data?.status_message || 'Success!')
          changeLoader(false)
          navigate('/login')
        } else {
          errorToast(payload?.data?.status_message || 'Something went wrong')
          changeLoader(false)
        }
      })
    }
  }

  return (
    <div className="auth-wrapper-main">
      <div className="container">
        <div className="authbox">
          <div className="auth-left">
            <div className="auth-page-title">Reset Your Password</div>
            <p className="auth-page-sub-title">The password must be different than before</p>

            <div className="auth-form-content">
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="form-group input_text">
                  <label className="form-control-label">
                    New Password<span className="text-danger"> *</span>
                  </label>
                  <Controller
                    name="password"
                    control={control}
                    render={({ field: { value, onChange }, fieldState }) => (
                      <>
                        <div className="pass-group">
                          <input
                            type={showPassword ? 'text' : 'password'}
                            className={`form-control  ${errors?.password ? 'error-input' : ''}`}
                            value={value}
                            placeholder="Enter New Password"
                            autoComplete="false"
                            onChange={(val) => {
                              onChange(val)
                              trigger('password')
                            }}
                          />
                          <span onClick={onPasswordEyeClick} className={`fa toggle-password ${showPassword ? 'fa-eye' : 'fa-eye-slash'}`} />
                        </div>
                        <small>{fieldState?.error?.message}</small>
                      </>
                    )}
                  />
                </div>

                <div className="form-group input_text mb-5">
                  <label className="form-control-label">
                    Confirm Password<span className="text-danger"> *</span>
                  </label>
                  <Controller
                    name="confirmPassword"
                    control={control}
                    render={({ field: { value, onChange }, fieldState }) => (
                      <>
                        <div className="pass-group">
                          <input
                            type={showConfirmPassword ? 'text' : 'password'}
                            className={`form-control  ${errors?.confirmPassword ? 'error-input' : ''}`}
                            value={value}
                            autoComplete="false"
                            placeholder="Enter Confirm Password"
                            onChange={(val) => {
                              onChange(val)
                              trigger('confirmPassword')
                            }}
                          />
                          <span
                            onClick={onConfirmPasswordEyeClick}
                            className={`fa toggle-password ${showConfirmPassword ? 'fa-eye' : 'fa-eye-slash'}`}
                          />
                        </div>
                        <small>{fieldState?.error?.message}</small>
                      </>
                    )}
                  />
                </div>

                <div className="form-group mb-3">
                  <button className="btn btn-lg btn-block w-100 btn-primary" type="submit">
                    Reset Password
                  </button>
                </div>
              </form>
            </div>
          </div>
          {/* <div className="auth-right auth-reset-pwd-bg-img"></div> */}
        </div>
      </div>
    </div>
  )
}

export default ResetPassword
